import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';

// You can declare a mixin as the same style as components.
@Component
export default class BusinessModeMixin extends Vue {
  @Getter('shouldCustomerValidateOrder', { namespace: 'app/order' })
  protected shouldCustomerValidateOrder!: boolean;

  @Getter('isBusinessBuild')
  protected isBusinessMode!: boolean;

  get isBusinessModeWithCustomerValidation() {
    return this.isBusinessMode && this.shouldCustomerValidateOrder;
  }
}
